export const selectFiles = state => state.files;
